var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('img',{attrs:{"src":"/img/gmmc.jpg","height":"663px","width":"1349px","alt":""}})])])
}]

export { render, staticRenderFns }